import {Subject} from 'rxjs';

export class FetchEducationalLicenses {
    public static readonly type = '[Educational Licenses] FetchEducationalLicenses';

    constructor(public cancellationToken?: Subject<any>) {
    }

}
